(() => {
  function imageOnly(el) {
    if (!(el instanceof HTMLElement)) return false;
    if (el.matches('img,picture')) return true;
    if (!el.matches('p,div,a,figure')) return false;
    const imgs = el.querySelectorAll('img');
    if (imgs.length !== 1) return false;
    const text = (el.textContent || '').trim();
    return text.length === 0 && !el.querySelector('video,iframe,button');
  }
  function format(root) {
    if (root.dataset.trpGalleryReady === 'true') return;
    root.dataset.trpGalleryReady = 'true';
    const allParents = [root, ...root.querySelectorAll('div,section,article')];
    allParents.forEach(parent => {
      if (parent.closest('.trp-imported-image-grid')) return;
      const children = Array.from(parent.children);
      let group = [];
      function flush() {
        if (group.length < 2) { group = []; return; }
        const grid = document.createElement('div');
        grid.className = 'trp-imported-image-grid';
        parent.insertBefore(grid, group[0]);
        group.forEach(node => {
          const item = document.createElement('div');
          item.className = 'trp-imported-image-item';
          item.appendChild(node);
          grid.appendChild(item);
        });
        group = [];
      }
      children.forEach(node => {
        if (imageOnly(node)) group.push(node);
        else flush();
      });
      flush();
    });
  }
  function init(scope=document) {
    if (scope.matches?.('[data-product-description]')) format(scope);
    scope.querySelectorAll('[data-product-description]').forEach(format);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();